import React, { createContext, useState } from 'react';

const DeadlineModalContext = createContext();
export default DeadlineModalContext;

const { Provider } = DeadlineModalContext;

// 모달 아이템
export const ModalItem = '20260921_modal';
export const ModalDeadline = '2026-09-28T00:00:00+09:00';

const DeadlineModalProvider = (props) => {
  const [showModal, setShowModal] = useState(false);

  const doShowModal = () => {
    const modalStatus = JSON.parse(localStorage.getItem(ModalItem));
    const today = new Date().getTime();
    const deadline = new Date(ModalDeadline).getTime();

    !modalStatus && today < deadline
      ? setShowModal(true)
      : modalStatus && modalStatus.timestamp < today && today < deadline
      ? setShowModal(true)
      : setShowModal(false);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const dayCloseModal = () => {
    const nextDay = new Date();
    nextDay.setDate(nextDay.getDate() + 1);
    const time = JSON.stringify({
      timestamp: nextDay.getTime(),
    });
    localStorage.setItem(ModalItem, time);
    setShowModal(false);
  };

  const context = {
    state: {
      showModal,
    },
    actions: {
      setShowModal,
      closeModal,
      dayCloseModal,
      doShowModal,
    },
  };

  return <Provider value={context}>{props.children}</Provider>;
};

export { DeadlineModalProvider };
